import React from 'react';
import { Paper, TableContainer } from '@mui/material';

/// Container padrão das listagens.
///
/// Em telas largas mantém a tabela tradicional. Abaixo de `sm` a tabela é
/// reflowada em cartões: o cabeçalho some e cada célula exibe o próprio rótulo,
/// lido do atributo `data-label`. A célula marcada com `data-actions` vira o
/// rodapé de ações do cartão, e linhas com `colSpan` (carregando, lista vazia)
/// seguem ocupando a largura toda, sem virar cartão.
export default function ResponsiveTable({ children, sx, ...props }) {
  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={[
        (theme) => ({
          [theme.breakpoints.down('sm')]: {
            border: 0,
            backgroundColor: 'transparent',

            '& table, & tbody, & tr, & td': { display: 'block' },
            '& table': { minWidth: 0 },

            // O cabeçalho continua no DOM para leitores de tela.
            '& thead': {
              position: 'absolute',
              width: 1,
              height: 1,
              padding: 0,
              overflow: 'hidden',
              clip: 'rect(0 0 0 0)',
              clipPath: 'inset(50%)',
              whiteSpace: 'nowrap',
              border: 0,
            },

            '& tbody tr': {
              position: 'relative',
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: `${theme.shape.borderRadius}px`,
              backgroundColor: theme.palette.background.paper,
              padding: theme.spacing(1, 1.5),
              marginBottom: theme.spacing(1.5),
            },
            '& tbody tr:last-of-type': { marginBottom: 0 },

            '& tbody td': {
              border: 0,
              width: 'auto',
              padding: theme.spacing(0.5, 0),
              textAlign: 'left',
            },

            // Célula rotulada: rótulo à esquerda, valor à direita.
            // `flexDirection` é explícito porque o MUI aplica `row-reverse` em
            // células com `align="right"`, o que trocaria rótulo e valor de lado.
            '& tbody td[data-label]': {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: theme.spacing(2),
              textAlign: 'right',
            },
            '& tbody td[data-label]::before': {
              content: 'attr(data-label)',
              flexShrink: 0,
              textAlign: 'left',
              fontSize: theme.typography.pxToRem(12),
              fontWeight: 700,
              letterSpacing: 0.2,
              textTransform: 'uppercase',
              color: theme.palette.text.secondary,
            },

            // Ações ficam agrupadas no rodapé do cartão.
            '& tbody td[data-actions]': {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: theme.spacing(0.5),
              marginTop: theme.spacing(0.5),
              paddingTop: theme.spacing(1),
              borderTop: `1px dashed ${theme.palette.divider}`,
            },

            // Linhas de estado (carregando, vazio) não viram cartão.
            '& tbody tr:has(> td[colspan])': {
              border: 0,
              backgroundColor: 'transparent',
              padding: 0,
            },
            '& tbody td[colspan]': { textAlign: 'center' },
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </TableContainer>
  );
}
